import Autocompletes_Async from './Autocompletes_Async.vue'
import { throttle } from '@/libs/functions_utils'
import { defaultFun } from '../utils'
import { AUTOCOMPLETES_ASYNC } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: AUTOCOMPLETES_ASYNC,
    mixins: [ commonMixins ],
    data() {
        return {
            loading:false
        }
    },
    methods: {
        getData(data) {
            const { api, get_data, items = [] } = this.field
            const item_text = this.field['item-text']
            const _is_equal = items && items.map(item => item[item_text]).includes(data) // 列表中包含相应的数据
            if (// 搜索框为空
                _is_equal) {
                return 
            }
            let { 
                 out_params,
                 search_key 
                } = this.field
            out_params = out_params || {}
            search_key = search_key || 'search'
            this.loading = true
            this.$util.http.get(api, {
                ...out_params,
                [search_key]: data
              }).then(data => {
                get_data && get_data(data)
              }).finally(() => {
                this.loading = false
              })
        }
    },
    watch:{
        'field.delay':function(value) {
            if (value === 0 || value) {
                this.throttle_ac = throttle.call(this, this.getData, value)
            }
        }
    },
    mounted() {
        const delay = this.field.delay || 500
        this.throttle_ac = throttle.call(this, this.getData, delay)
        this.throttle_ac()
    },
    render(h) {
        let update_search_input = defaultFun
        const {
             key,
                // eslint-disable-next-line 
             slots,scopedSlots,delay,api,out_params, search_key,get_data,
             _type = 'text',
             blur = defaultFun,
             change,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
            if (params['update:search-input']) {
                update_search_input = params['update:search-input']
                delete params['update:search-input']
            }
        params.type = _type
        return h(Autocompletes_Async, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                propsg: {
                    ...params,
                    placeholder: params.placeholder || '请输入关键字进行查找',
                    'no-data-text':params.noDataText || '暂无数据',
                    loading:this.loading,
                    value: this.my_value[key]
                },
                callBacks:data => this.throttle_ac(data)
            },
            on: {
                blur,
                change:(data) => {
                    this.my_value[key] = data
                    if (!change) {
                        return 
                    }
                    const target = (this.field.items || []).filter(item => data === item[this.field['item-value']])[0]
                    change(data, target)
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
                'update:search-input': update_search_input
            }
        })
    }
}